"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConsumedLoanTapeMetadataProperties = exports.extractLoanTapeMetadata = exports.parseLoanTapeMetadataProperties = exports.isLoanTapeMetaDataIterable = void 0;
const remeda_1 = require("remeda");
const common_1 = require("@finley-technologies/common");
const finley_types_1 = require("@finley-technologies/finley-types");
const formula_engine_1 = require("@finley-technologies/formula-engine");
const isLoanTapeMetaDataIterable = (str) => finley_types_1.Receivable.CreditFacility.LoanTapeMetadataIterable.includes(str);
exports.isLoanTapeMetaDataIterable = isLoanTapeMetaDataIterable;
const parseLoanTapeMetadataProperties = (formula) => {
    const { variables } = (0, formula_engine_1.inspectDependencies)(formula);
    const matches = Array.from(variables).map((variable) => {
        const [loanTapeMetadata, key] = variable.split('.');
        if (loanTapeMetadata === 'loanTapeMetadata' &&
            (0, exports.isLoanTapeMetaDataIterable)(key)) {
            return key;
        }
        return null;
    });
    return (0, remeda_1.compact)(matches);
};
exports.parseLoanTapeMetadataProperties = parseLoanTapeMetadataProperties;
const extractLoanTapeMetadata = (fields) => {
    return Object.entries(fields).reduce((acc, [key, val]) => {
        if (!(0, exports.isLoanTapeMetaDataIterable)(key) ||
            val === undefined ||
            val === null) {
            return acc;
        }
        if (key === 'reportingDate') {
            if (common_1.typeguards.isFullDateStr(val)) {
                // eslint-disable-next-line no-param-reassign
                acc[key] = val;
            }
        }
        else if (key === 'configuredActiveWaivers') {
            if (Array.isArray(val)) {
                // eslint-disable-next-line no-param-reassign
                acc[key] = val;
            }
        }
        else if (typeof val === 'number') {
            // eslint-disable-next-line no-param-reassign
            acc[key] = val;
        }
        return acc;
    }, {});
};
exports.extractLoanTapeMetadata = extractLoanTapeMetadata;
const getConsumedLoanTapeMetadataProperties = (config) => {
    const { _config_: { intermediateCalcConfigs }, } = config;
    const consumedProperties = new Set();
    intermediateCalcConfigs.forEach((icc) => {
        if (icc.config.type === 'formula') {
            const variables = (0, exports.parseLoanTapeMetadataProperties)(icc.config.formula);
            variables.forEach((variable) => consumedProperties.add(variable));
        }
    });
    return Array.from(consumedProperties);
};
exports.getConsumedLoanTapeMetadataProperties = getConsumedLoanTapeMetadataProperties;
//# sourceMappingURL=parseLoanTapeMetadata.js.map